import { render, staticRenderFns } from "./AutomaticDigitizationSettings.vue?vue&type=template&id=f1d707f6&"
import script from "./AutomaticDigitizationSettings.vue?vue&type=script&lang=js&"
export * from "./AutomaticDigitizationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports